export const euro = (cents: number) => `€${(cents / 100).toFixed(2)}`;

export function timeAgo(iso?: string | null): string {
  if (!iso) return '';
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return `${s}s`;
  return `${Math.floor(s / 60)}min`;
}

export const STATUS_LABEL: Record<string, string> = {
  PENDING_PAYMENT: 'À encaisser',
  RECEIVED: 'Reçu',
  PREPARING: 'En préparation',
  READY: 'Prêt !',
  COMPLETED: 'Terminé',
};
